var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSolicitante(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.90027 8.22804C9.6219 8.54461 10.2703 9.00746 10.8046 9.58743C10.8855 9.6771 10.9316 9.79299 10.9342 9.9139V11.9127C10.9342 12.0452 10.8817 12.1723 10.7882 12.266C10.6946 12.3597 10.5678 12.4124 10.4355 12.4124H2.78782C2.65669 12.4124 2.53082 12.3606 2.43748 12.2684C2.34413 12.1761 2.29081 12.0507 2.28906 11.9193V9.92056C2.29011 9.79735 2.33625 9.67881 2.41874 9.58743C2.95303 9.00746 3.6014 8.54461 4.32302 8.22804C5.04465 7.91148 5.82388 7.74805 6.61165 7.74805C7.39942 7.74805 8.17865 7.91148 8.90027 8.22804Z",
    fill: "#A7A7A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61075 7.08176C7.89622 7.08176 8.9383 6.03773 8.9383 4.74986C8.9383 3.46199 7.89622 2.41797 6.61075 2.41797C5.32528 2.41797 4.2832 3.46199 4.2832 4.74986C4.2832 6.03773 5.32528 7.08176 6.61075 7.08176Z",
    fill: "#A7A7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolicitante);
export default __webpack_public_path__ + "static/media/IconSolicitante.7ecb7d24ca25ee28dbabab329d2f9be0.svg";
export { ForwardRef as ReactComponent };